<template>
  <div class="resources-hub">
    <UkaskoLoader :is-loading="!isReady">
      <div class="resources-hub__top">
        <AppHeader
          class="resources-hub__header"
          :animation-enabled="false"
          :is-mobile-menu-open="isMobileMenuOpen"
          @header-resize="closeMobileMenuOnResize"
        />
        <HubHero />
        <HubTelegram />
      </div>
      <div class="resources-hub__content">
        <HubLibrary />
        <HubRequest />
        <HubFormats />
        <HubChannel />
        <ResourcesFaq :page="page" />
      </div>
      <div class="resources-hub__footer-edge"></div>
      <AppFooter />
    </UkaskoLoader>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { RESOURCES_HUB_DEFAULT_SELECTION, RESOURCES_HUB_TEXT_PAGE } from '../../config';
import { extractUtmParams, getPublishedResourceDocumentSlugs } from '../../lib';
import ResourcesFaq from '../resources-faq';
import HubChannel from './hub-channel';
import HubFormats from './hub-formats';
import HubHero from './hub-hero';
import HubLibrary from './hub-library';
import HubRequest from './hub-request';
import HubTelegram from './hub-telegram';
import { UkaskoLoader } from '@/shared/ui/ukasko-loader';
import { AppFooter, AppHeader, promoMobileMenu } from '@/widgets/promo';

const PROMO_TEXT_PAGE = 'promo';

export default {
  mixins: [ promoMobileMenu ],
  components: { AppHeader, AppFooter, UkaskoLoader, HubHero, HubTelegram, HubLibrary, HubRequest, HubFormats, HubChannel, ResourcesFaq },
  data() {
    return {
      page: RESOURCES_HUB_TEXT_PAGE,
    };
  },
  computed: {
    ...mapGetters('textBlocksModule', ['isTextBlocksReady']),
    isReady() {
      return this.isTextBlocksReady(PROMO_TEXT_PAGE) && this.isTextBlocksReady(this.page);
    },
  },
  created() {
    if (!this.isTextBlocksReady(PROMO_TEXT_PAGE)) {
      this.fetchTextBlocks(PROMO_TEXT_PAGE);
    }
    this.fetchTextBlocks(this.page);
    this.rememberUtm(extractUtmParams(this.$route.query));
    this.startSelection(getPublishedResourceDocumentSlugs(RESOURCES_HUB_DEFAULT_SELECTION));
  },
  methods: {
    ...mapActions('textBlocksModule', ['fetchTextBlocks']),
    ...mapActions('agentResourcesModule', ['rememberUtm', 'startSelection']),
  },
};
</script>

<style lang="scss" scoped>
.resources-hub {
  font-family: 'Geist', sans-serif;
  color: #373A3D;
  background-color: #FCFDFF;

  &__top {
    position: relative;
    background-color: #CADDFC;
    padding-bottom: 96px;

    @media (max-width: 800px) {
      padding-bottom: 64px;
    }
  }

  &__header {
    position: relative;
    z-index: 2;
  }

  &__content {
    position: relative;
    margin-top: -48px;
    padding: 48px 0 96px;
    background-color: #FCFDFF;
    border-radius: 48px 48px 0 0;

    @media (max-width: 800px) {
      margin-top: -32px;
      padding: 32px 0 64px;
      border-radius: 32px 32px 0 0;
    }
  }

  &__footer-edge {
    height: 32px;
    background-color: #313437;
    border-radius: 32px 32px 0 0;
  }
}
</style>
